import { render } from "./CreditAskResultComponent.vue?vue&type=template&id=16351891&scoped=true"
import script from "./CreditAskResultComponent.vue?vue&type=script&lang=js"
export * from "./CreditAskResultComponent.vue?vue&type=script&lang=js"

import "./CreditAskResultComponent.vue?vue&type=style&index=0&id=16351891&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16351891"]])

export default __exports__